import { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Modal } from "@mui/material";
import EditAssetModal from "./EditAssetModal";
import { Button } from "@mui/material";
import axios from "axios";
import CheckAssetModal from "./CheckAssetModal";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import DamagesModal from "./DamagesModal";
import BlockIcon from "@mui/icons-material/Block";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import TableRowsIcon from "@mui/icons-material/TableRows";
import LogsModal from "./LogsModal";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteAssetModal from "./DeleteAssetModal";
import AssetImageModal from "./AssetImageModal";

export default function IndvAsset({
  asset,
  refreshAssets,
  assetTypes,
  assetLocations,
}) {
  const url = process.env.REACT_APP_URL;
  const [lastUser, setLastUser] = useState("");
  const [lastDate, setLastDate] = useState("");

  //Modals
  const [openCheckAsset, setOpenCheckAsset] = useState(false);
  const [openDamages, setOpenDamages] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [openLogs, setOpenLogs] = useState(false);
  const [openImage, setOpenImage] = useState(false);

  useEffect(() => {
    fetchLastUserInfo();
  }, []);

  const fetchLastUserInfo = async () => {
    await axios
      .post(`${url}/assets/last-asset-holder`, { assetId: asset.assetId })
      .then((res) => {
        if (res.data?.lastUser?.userName) {
          setLastUser(res.data.lastUser.userName);
          setLastDate(moment(res.data.lastUser.date).format("DD/MM/YY"));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <tr
        className={asset.checkedIn ? "" : "checkedOut"}
        style={
          asset.disabled
            ? { backgroundColor: "#ffc3c3" }
            : { backgroundColor: "#fff" }
        }
      >
        <td className="asset-id-cell">
          <Tooltip title={`${asset.company} asset`}>
            <b>{asset.assetId}</b>
          </Tooltip>
        </td>
        <td>
          <Tooltip title="Click to see asset image">
            <a href={asset.assetImage} target="_blank">
              {asset.assetName}
            </a>
          </Tooltip>
        </td>
        <td>
          <Tooltip
            title={
              asset.serialNumber ? `Serial Number: ${asset.serialNumber}` : null
            }
            style={{ cursor: "pointer" }}
          >
            {asset.assetTypeName}
          </Tooltip>
        </td>
        <td>{asset.locationName}</td>
        <td style={{ cursor: "pointer" }}>
          {asset.owner ? (
            asset.userName
          ) : (
            <Tooltip
              title={
                lastUser
                  ? `Last checked by: ${lastUser}, checked in: ${lastDate}`
                  : "No previous owner"
              }
            >
              <BlockIcon fontSize="large" color="error" />
            </Tooltip>
          )}
        </td>
        <td>
          <Tooltip title="Log Damages">
            <IconButton onClick={() => setOpenDamages(true)}>
              <BrokenImageIcon
                fontSize="large"
                color={asset.damages.length > 0 ? "error" : ""}
                sx={{ cursor: "pointer" }}
                onClick={() => setOpenDamages(true)}
              />
            </IconButton>
          </Tooltip>
        </td>
        <td>
          {asset.checkedIn ? (
            <Button
              variant="contained"
              color="warning"
              onClick={() => setOpenCheckAsset(true)}
              className="check-btn"
              disabled={asset.disabled}
            >
              Check out
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              onClick={() => setOpenCheckAsset(true)}
              className="check-btn"
              disabled={asset.disabled}
            >
              Check In
            </Button>
          )}
        </td>
        {localStorage.getItem("access") == process.env.REACT_APP_ADMIN_ID ? (
          <>
            <td>
              {asset.checkedIn ? (
                <Tooltip title="Edit Asset">
                  <IconButton
                    disabled={asset.disabled}
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <EditIcon
                      fontSize="large"
                      color={asset.disabled ? "" : "warning"}
                      onClick={() => {
                        setOpenEdit(true);
                      }}
                      sx={{ cursor: "pointer" }}
                    />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Check In to Edit">
                  <BlockIcon fontSize="large" color="error" />
                </Tooltip>
              )}
            </td>
            <td>
              {asset.checkedIn ? (
                <Tooltip title="Delete Asset">
                  <IconButton
                    disabled={asset.disabled}
                    onClick={() => {
                      setOpenDelete(true);
                    }}
                  >
                    <DeleteIcon
                      fontSize="large"
                      color={asset.disabled ? "" : "error"}
                      sx={{ cursor: "pointer" }}
                    />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Check In to Delete">
                  <BlockIcon fontSize="large" color="error" />
                </Tooltip>
              )}
            </td>
            <td>
              <Tooltip title="Access Asset Logs">
                <IconButton onClick={() => setOpenLogs(true)}>
                  <TableRowsIcon color="primary" />
                </IconButton>
              </Tooltip>
            </td>
          </>
        ) : null}
      </tr>
      {/* MODALS */}
      <Modal open={openCheckAsset}>
        <CheckAssetModal
          asset={asset}
          refreshAssets={refreshAssets}
          assetLocations={assetLocations}
          handleClose={setOpenCheckAsset}
        />
      </Modal>
      <Modal open={openEdit}>
        <EditAssetModal
          asset={asset}
          refreshAssets={refreshAssets}
          assetTypes={assetTypes}
          assetLocations={assetLocations}
          handleClose={setOpenEdit}
        />
      </Modal>
      <Modal open={openDelete}>
        <DeleteAssetModal
          assetId={asset.assetId}
          assetName={asset.assetName}
          refreshAssets={refreshAssets}
          handleClose={setOpenDelete}
        />
      </Modal>
      <Modal open={openDamages}>
        <DamagesModal
          asset={asset}
          refreshAssets={refreshAssets}
          handleClose={setOpenDamages}
        />
      </Modal>
      <Modal open={warningModal}>
        <Box className="warning-modal">
          <section className="warning-modal-section">
            <h2>Warning</h2>
            <p>
              You are unable to check this asset in as you did not check the
              asset out. Please discuss with asset owner if you require use of
              the asset.
            </p>
            <Button
              variant="contained"
              color="error"
              onClick={() => setWarningModal(false)}
            >
              Close
            </Button>
          </section>
        </Box>
      </Modal>
      <Modal open={openLogs}>
        <LogsModal
          assetId={asset.assetId}
          handleClose={setOpenLogs}
          logsType="asset"
          assetImage={asset.assetImage}
        />
      </Modal>
      <Modal open={openImage}>
        <AssetImageModal
          assetImage={asset.assetImage}
          handleClose={setOpenImage}
        />
      </Modal>
    </>
  );
}
